import { Directive, effect, ElementRef, HostBinding, Inject, input, NgZone, PLATFORM_ID, Renderer2, SimpleChange, TemplateRef, ViewContainerRef } from '@angular/core';
import { PrimeNGConfig } from 'primeng/api';
import { Tooltip } from 'primeng/tooltip';

@Directive({
  selector: '[ospTooltip]',
  standalone: true,
})
export class TooltipDirective extends Tooltip {
  @HostBinding('class.osp-tooltip') protected hostCssClassEnabled = true;
  $ospTooltip = input<string | TemplateRef<HTMLElement> | undefined | null>(undefined, { alias: 'ospTooltip' }); // tooltip content
  $tooltipPosition = input<'right' | 'left' | 'top' | 'bottom' | string | undefined>('right', { alias: 'tooltipPosition' });
  $tooltipDisabled = input<boolean>(false, { alias: 'tooltipDisabled' });

  constructor(
    @Inject(PLATFORM_ID) platformId: object,
    el: ElementRef,
    zone: NgZone,
    config: PrimeNGConfig,
    renderer: Renderer2,
    viewContainer: ViewContainerRef
  ) {
    super(platformId, el, zone, config, renderer, viewContainer);

    // Overriding of z-index to make sure it is always on top
    this.setOption({ tooltipZIndex: '10000' });

    effect(() => {
      const previousValue = this.content;
      const currentValue = this.$tooltipDisabled() ? '' : this.$ospTooltip();
      if (previousValue !== currentValue) {
        super.ngOnChanges({ content: <SimpleChange>{ previousValue, currentValue } });
      }
    });

    effect(() => {
      const previousValue = this.tooltipPosition;
      const currentValue = this.$tooltipPosition() || 'right';
      if (previousValue !== currentValue) {
        super.ngOnChanges({ tooltipPosition: <SimpleChange>{ previousValue, currentValue } });
      }
    });
  }

}
